export default __webpack_public_path__ + "static/service-2-0857f025f31928c51574f59da8cb40c0.webp";